<svg-icon
  class="max-h-4 max-w-4 text-text-light"
  [key]="svgIconKey()"
  [libUiTooltip]="provisionalStatusTooltip"
  tooltipPosition="bottom"
></svg-icon>
<ng-template #provisionalStatusTooltip>
  <div class="px-3 py-2">
    <div class="typo-h7-light">{{ tooltipTextKey() | translate }}</div>
  </div>
</ng-template>
